import React from 'react';
import { Button, Typography, Box, LayoutContent, LayoutContentCenter, LayoutControls, ContentFrame, ScreenContainer, } from '@pinwheel/origami';
import useLinkNavigate from '../../hooks/useLinkNavigate';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
import QuestionMarkCircle from '../../assets/QuestionMarkCircle';
import { useOpts } from '../../context';
import { useReturnButtonText } from '../../hooks/useReturnButtonText';
export default function ReturnToSearch() {
    var navigate = useLinkNavigate();
    var getLocalizedString = useGetLocalizedString();
    var exit = useOpts().exit;
    var returnButtonText = useReturnButtonText();
    return (React.createElement(ScreenContainer, null,
        React.createElement(ContentFrame, null,
            React.createElement(LayoutContent, null,
                React.createElement(LayoutContentCenter, null,
                    React.createElement(Box, null,
                        React.createElement(QuestionMarkCircle, { size: 81 })),
                    React.createElement(Box, null,
                        React.createElement(Typography, { as: "h2", variant: "header", color: "title", align: "center" }, getLocalizedString('SEARCH_FOR_A_DIFFERENT_ACCOUNT'))),
                    React.createElement(Box, null,
                        React.createElement(Typography, { variant: "body", align: "center" }, getLocalizedString('SEARCH_OUR_DATABASE'))))),
            React.createElement(LayoutControls, null,
                React.createElement(Button, { eventId: "ReturnToSearch-continue", onClick: function () { return navigate('/search/search'); } }, getLocalizedString('SEARCH_PAYROLL_PROVIDERS')),
                React.createElement(Button, { onClick: function () { return exit(); }, variant: "ghost" }, returnButtonText)))));
}
